// Marketplace seed catalog moved to shared/data/marketplaceCatalog.js so
// canvas's /marketplace preview surface and the marketplace sub-app
// import from one source instead of cross-importing each other (Phase 10
// no-restricted-imports). This file remains as a re-export shim — drop
// it once consumers are migrated to import directly from shared/.

export { default } from '../../shared/data/marketplaceCatalog.js'
